import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class AppConfigService {

  public appConfig: object;

  constructor (private injector: Injector) { }

  public async loadAppConfig() {
    let http = this.injector.get(HttpClient);
    try {
      const data = await firstValueFrom(http.get('/assets/app-config.json'));
      this.appConfig = data;
    } catch (error) {
      console.error('Error loading app config:', error);
      throw error;
    }
  }

  get config() {
    return this.appConfig;
  }
}
